/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Merge_Event_Group_Order_By_StartInputs */

const en_merge_event_group_order_by_start = /** @type {(inputs: Merge_Event_Group_Order_By_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start Time`)
};

const fr_merge_event_group_order_by_start = /** @type {(inputs: Merge_Event_Group_Order_By_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Heure de debut`)
};

const de_merge_event_group_order_by_start = /** @type {(inputs: Merge_Event_Group_Order_By_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Startzeit`)
};

const it_merge_event_group_order_by_start = /** @type {(inputs: Merge_Event_Group_Order_By_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ora di inizio`)
};

const ru_merge_event_group_order_by_start = /** @type {(inputs: Merge_Event_Group_Order_By_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Время начала`)
};

const es_merge_event_group_order_by_start = /** @type {(inputs: Merge_Event_Group_Order_By_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hora de inicio`)
};

const zh_cn2_merge_event_group_order_by_start = /** @type {(inputs: Merge_Event_Group_Order_By_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`开始时间`)
};

const ja_merge_event_group_order_by_start = /** @type {(inputs: Merge_Event_Group_Order_By_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`開始時間`)
};

const hi_merge_event_group_order_by_start = /** @type {(inputs: Merge_Event_Group_Order_By_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`समय शुरू`)
};

const pt_pt2_merge_event_group_order_by_start = /** @type {(inputs: Merge_Event_Group_Order_By_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hora de início`)
};

/**
* | output |
* | --- |
* | "Start Time" |
*
* @param {Merge_Event_Group_Order_By_StartInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const merge_event_group_order_by_start = /** @type {((inputs?: Merge_Event_Group_Order_By_StartInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Merge_Event_Group_Order_By_StartInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_merge_event_group_order_by_start(inputs)
	if (locale === "de") return de_merge_event_group_order_by_start(inputs)
	if (locale === "it") return it_merge_event_group_order_by_start(inputs)
	if (locale === "ru") return ru_merge_event_group_order_by_start(inputs)
	if (locale === "es") return es_merge_event_group_order_by_start(inputs)
	if (locale === "zh-CN") return zh_cn2_merge_event_group_order_by_start(inputs)
	if (locale === "ja") return ja_merge_event_group_order_by_start(inputs)
	if (locale === "hi") return hi_merge_event_group_order_by_start(inputs)
	if (locale === "pt-PT") return pt_pt2_merge_event_group_order_by_start(inputs)
	return en_merge_event_group_order_by_start(inputs)
});